import axios from "axios"
import {API_URL} from "../constants"

export async function getFiles(id: string) {

    const res = await axios({
        method : 'GET',
        url: `${API_URL}/files/${id}`,
        withCredentials: true,
        headers: {
            "Content-Type": "application/pdf",
        }
    })
    return res.data;
}

export async function putFiles(id:string, privacyMode : boolean ,route : string, filesData: FormData, onProgress?: (percent: number) => void) {
    await axios({
        method : 'PUT',
        url : `${API_URL}/files/${route}/${id}`,
        params : { privacy : privacyMode },
        withCredentials: true ,
        data : filesData,
        headers : {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
            if (progressEvent.total && onProgress) {
                const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
                );
                onProgress(percentCompleted);
            }
        }
    })
}

export async function deleteFiles(id: string, privacyMode : boolean,name:string) {
    await axios({
        method : 'DELETE',
        url : `${API_URL}/files/${id}`,
        params : { privacy : privacyMode },
        withCredentials: true ,
         data : {
            file_name : name
        },
        headers : {
            "Content-Type": "application/json",
        }
       
    })
}